<template>
  <!-- Title is its own string, not the item-mapping one: this modal creates customers, and
       reusing `item-mapping.dev-tools.title` had it announce itself as varenummer-opsætning. -->
  <BaseModal :modalTitle="$t('W: Testværktøjer til kundenummer-opsætning')">
    <template #titleBadge>
      <DevBadge />
    </template>

    <div class="flex flex-col gap-3">
      <p>
        {{
          $t(
            'W: Opretter en testkunde i BC for hver kunde, privatkunde og forsikringskunde uden kundenummer, og skriver nummeret ind i opsætningen.'
          )
        }}
      </p>
      <span
        v-if="resultMessage"
        class="text-sm text-text-secondary">
        {{ resultMessage }}
      </span>
      <InfoText
        v-if="errorText"
        :text="errorText"
        theme="alert" />
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('area.business-central.customer-mapping.dev-tools.create-test-customer')"
        :isLoading="isLoading"
        @button-click="onConfirmClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { useToast } from '@/globals/typescript/utils/toast'
import type { PropType } from 'vue'

export default {
  name: 'CreateTestBcCustomersModal',

  props: {
    onConfirm: { type: Function as PropType<() => Promise<string>>, required: true },
  },

  data() {
    return {
      isLoading: false,
      resultMessage: '',
      errorText: '',
    }
  },

  methods: {
    async onConfirmClick(): Promise<void> {
      this.isLoading = true
      this.errorText = ''
      try {
        this.resultMessage = await this.onConfirm()
        useToast().success(this.resultMessage)
      } catch (err) {
        this.errorText = err instanceof Error && err.message ? err.message : this.$t('error.common.standard')
        useToast().error(this.errorText)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
